// extracted by mini-css-extract-plugin
export default {"headline":"P09Wc4yGLp_2nj1jkSzA","clickableRow":"ASltr78bCfrM6lCHAUI3","points":"kH2E950UgjJWADe3qatC","valueLink":"kfPYZGg1ovMfaZoA9Eag","link":"nsUmrJG1ZSF4TTQUSvFm"};